import { isEmpty } from 'radash';
import { IAllFavoriteItem, IFavoriteItem } from '@modules/favorite/domain/models/favourite.model';
import { CollectionResponse, MemberFavoriteResultResponse, ProductResponse, RecipeRelateResponse } from '@modules/libs/graphql/generated/graphql';
export class AllFavoriteItemEntityMapper {
  public static toDomain(favoriteResultResponse: MemberFavoriteResultResponse): IAllFavoriteItem {
    const {
      data,
      productTotal,
      recipeTotal,
      collectionTotal
    } = favoriteResultResponse;
    const {
      recipes,
      products,
      collections
    } = data;
    return {
      recipes: this.favoriteRecipeMapper(recipes),
      products: this.favoriteProductMapper(products),
      collections: this.favoriteCollectionMapper(collections),
      totalProducts: productTotal,
      totalRecipes: recipeTotal,
      totalCollections: collectionTotal
    };
  }
  private static favoriteRecipeMapper(recipes: RecipeRelateResponse[]): IFavoriteItem[] {
    return recipes.map(data => {
      return {
        id: data.id,
        name: data.title,
        imageUrl: data.thumbUrl,
        videoUrl: null,
        slug: isEmpty(data.slugUrl) ? data.id.toString() : data.slugUrl,
        viewer: 200000,
        tag: data.recipeMeatCategory.map(({
          title
        }) => title),
        menuAmount: 0
      };
    });
  }
  private static favoriteProductMapper(products: ProductResponse[]): IFavoriteItem[] {
    return products.map(data => {
      return {
        id: data.id,
        name: data.title,
        imageUrl: data.thumbUrl,
        videoUrl: null,
        slug: isEmpty(data.slugUrl) ? data.id.toString() : data.slugUrl,
        viewer: 200000,
        tag: data.tag,
        menuAmount: 0
      };
    });
  }
  private static favoriteCollectionMapper(collections: CollectionResponse[]): IFavoriteItem[] {
    return collections.map(data => {
      return {
        id: data.id,
        name: data.title,
        imageUrl: data.thumbUrl,
        videoUrl: data.video,
        slug: data.slugUrl,
        viewer: 200000,
        tag: [],
        menuAmount: data.recipeListTotal
      };
    });
  }
}